<template>
  <div style="gap: 8px;">
    <template v-if="![$store.state.centralizedWorkspace, 'spontaneous'].includes(activeWorkspace)">
      <v-tooltip
        bottom
      >
        <template #activator="{ on }">
          <v-btn
            icon
            :disabled="!canPerformAction('CREATE_PROSPECT')"
            :to="{ name: 'add-candidate' }"
            v-on="on"
          >
            <v-icon>mdi-account-multiple-plus</v-icon>
          </v-btn>
        </template>
        <span>
          Créer un nouveau candidat
        </span>
      </v-tooltip>

      <v-tooltip
        bottom
      >
        <template #activator="{ on }">
          <v-btn
            :disabled="!canPerformAction('VIEW_PROSPECT')"
            icon
            :to="{ name: 'candidates-list'}"
            v-on="on"
          >
            <v-icon>mdi-folder-account</v-icon>
          </v-btn>
        </template>
        <span>
          Liste des candidats
        </span>
      </v-tooltip>
    </template>

    <UserInfo :user="user" />
  </div>
</template>

<script>
import UserInfo from '@/components/UserInfo';

export default {
  name: 'DesktopHeaderActions',
  components: { UserInfo },
  props: {
    user: {
      type: Object,
      required: true
    },
    activeWorkspace: {
      type: String,
      required: true
    },
    canPerformAction: {
      type: Function,
      required: true
    }
  }
};
</script>
